var React = require('react');

function CrossInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.64113 6.98014L13.6128 3.00851C14.1291 2.53191 14.1291 1.73759 13.6128 1.26099L12.739 0.387234C12.2624 -0.129078 11.4681 -0.129078 10.9915 0.387234L7.01986 4.35887L3.00851 0.387234C2.53191 -0.129078 1.73759 -0.129078 1.26099 0.387234L0.387234 1.26099C-0.129078 1.73759 -0.129078 2.53191 0.387234 3.00851L4.35887 6.98014L0.387234 10.9915C-0.129078 11.4681 -0.129078 12.2624 0.387234 12.739L1.26099 13.6128C1.73759 14.1291 2.53191 14.1291 3.00851 13.6128L7.01986 9.64113L10.9915 13.6128C11.4681 14.1291 12.2624 14.1291 12.739 13.6128L13.6128 12.739C14.1291 12.2624 14.1291 11.4681 13.6128 10.9915L9.64113 6.98014Z","fill":"#06444E"}));
}

CrossInline.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = CrossInline;

CrossInline.default = CrossInline;
